import { render, staticRenderFns } from "./ProTip.vue?vue&type=template&id=ccc00a8c&scoped=true&"
import script from "./ProTip.vue?vue&type=script&lang=ts&"
export * from "./ProTip.vue?vue&type=script&lang=ts&"
import style0 from "./ProTip.vue?vue&type=style&index=0&id=ccc00a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc00a8c",
  null
  
)

export default component.exports